import React, { useState } from 'react';
import useFetch from 'hooks/useFetch';
import { IGame } from 'utils/Interfaces';
import Modal from 'components/Modal/Modal';
import Loading from 'components/Loading/Loading';
import Card from 'components/Card/Card';
import MainContent from 'components/MainContent/MainContent';
import SideContent from 'components/SideContent/SideContent';

const HomePage = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { response, error, isLoading } = useFetch({
    method: 'get',
    url: `/games?_limit=4&_sort=id:desc`,
  });

  if (isLoading) {
    return <Loading />;
  }

  if (error.error) {
    return <Modal open={isOpen} info={error.body} type='error' onClose={() => setIsOpen(false)} />;
  }

  return (
    <>
      <MainContent />
      <SideContent>
        {response.map(({ id, cover_art, name }: IGame) => {
          return <Card id={id} image={cover_art?.formats?.small?.url} title={name} key={id} />;
        })}
      </SideContent>
    </>
  );
};

export default HomePage;
